import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AclColComponent, AclColModule } from 'angular-components-library/col';
// import {
//   AclSliderComponent,
//   AclSliderModule,
// } from 'angular-components-library/slider';
import { AclButtonModule } from 'angular-components-library/button';
import {
  AclContainerComponent,
  AclContainerModule,
} from 'angular-components-library/container';
import { AclCoreModule } from 'angular-components-library/core';
import { AclFooterModule } from 'angular-components-library/footer';
import {
  AclInputComponent,
  AclInputModule,
} from 'angular-components-library/input';
import {
  AclLabelComponent,
  AclLabelModule,
} from 'angular-components-library/label';
import { AclRowComponent, AclRowModule } from 'angular-components-library/row';
import {
  AclSelectComponent,
  AclSelectModule,
} from 'angular-components-library/select';
import { CoreModule } from '../../core/core.module';
import { TeyunaComponent } from './crud-builder/crud-builder.component';
import { DetailComponent } from './detail/detail.component';
import { ListComponent } from './list/list.component';


import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ComponentsModule } from '../components/components.module';


@NgModule({
  entryComponents: [
    DetailComponent,
    AclInputComponent,
    AclColComponent,
    AclContainerComponent,
    AclRowComponent,
    AclLabelComponent,
    AclSelectComponent,
    // AclSliderComponent,
  ],
  declarations: [ListComponent, DetailComponent, TeyunaComponent],
  imports: [
    CommonModule,
    ComponentsModule,
    MatTableModule,
    MatPaginatorModule,
    CoreModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    MatButtonToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatToolbarModule,
    MatDialogModule,
    MatMenuModule,
    ReactiveFormsModule,
    FormsModule,
    AclCoreModule,
    AclInputModule,
    AclColModule,
    AclContainerModule,
    AclRowModule,
    AclLabelModule,
    AclSelectModule,
    AclButtonModule,
    // AclSliderModule,
    AclFooterModule,
  ],
  exports: [ListComponent, DetailComponent, TeyunaComponent],
})
export class PagesModule {}
